import { reactIcons } from "../icons/reactIcons";

export const authCardData = [
  {
    id: 1,
    displayName: "Super Admin",
    route: "/super-admin",
    roles: "super_admin",
  },
  {
    id: 2,
    displayName: "OC-All-In",
    route: "/oc-all-in",
    roles: "oc_all_in",
  },
  {
    id: 3,
    displayName: "PLC",
    route: "/plc",
    roles: "plc",
  },
];

export const sidebarMenuItems = [
  {
    id: 1,
    parent: "",
    children: [
      {
        id: 1,
        title: "Term Data",
        icon: reactIcons.terDataCalendrCheck,
        path: "/oc-all-in/term-data",
      },
      {
        id: 2,
        title: "Events",
        icon: reactIcons.eventIcon,
        path: "/oc-all-in/events",
      },
      // {
      //   id: 3,
      //   title: "Employees",
      //   icon: reactIcons.employeeIcon,
      //   path: "/employees",
      // },
      {
        id: 4,
        title: "Rewards",
        icon: reactIcons.rewardsIcon,
        path: "/oc-all-in/rewards",
      },
      {
        id: 5,
        title: "Reports",
        icon: reactIcons.reportsicon,
        path: "/oc-all-in/reports",
      },
      {
        id: 6,
        title: "FAQ Management",
        icon: reactIcons.faqManagementIcon,
        path: "/oc-all-in/faq-management",
      },
    ],
  },
];

export const superAdminSidebaeMenuItems = [
  {
    id: 1,
    parent: "Global",
    children: [
      {
        id: 1,
        title: "Academic Year",
        icon: reactIcons.terDataCalendrCheck,
        path: "/super-admin/academic-year",
      },
      {
        id: 2,
        title: "Employees",
        icon: reactIcons.employeeIcon,
        path: "/super-admin/employees",
      },
      {
        id: 3,
        title: "Students",
        icon: reactIcons.student,
        path: "/super-admin/students",
      },
    ],
  },
  {
    id: 2,
    parent: "OC-All-IN",
    children: [
      {
        id: 4,
        title: "VP Codes",
        icon: reactIcons.key,
        path: "/super-admin/vp-codes",
      },
      {
        id: 5,
        title: "Department",
        icon: reactIcons.department,
        path: "/super-admin/department",
      },
      {
        id: 6,
        title: "Reward Type",
        icon: reactIcons.medal,
        path: "/super-admin/reward-type",
      },
    ],
  },
];

export const termCodeData = [
  {
    id: "1",
    placeHolder: "25F1",
    displayName: "Fall 1",
    termCode: "",
    startDate: null,
    endDate: null,
  },
  {
    id: "2",
    placeHolder: "25F2",
    displayName: "Fall 2",
    termCode: "",
    startDate: null,
    endDate: null,
  },
  {
    id: "3",
    placeHolder: "25S1",
    displayName: "Spring 1",
    termCode: "",
    startDate: null,
    endDate: null,
  },
  {
    id: "4",
    placeHolder: "25S2",
    displayName: "Spring 2",
    termCode: "",
    startDate: null,
    endDate: null,
  },
];

export const event_points = [
  "Main Event (500 Points)",
  "During Workday (100 Points)",
  "After Workday  (200 Points)",
  "Bonus  (300 Points)",
];

export const event_term = ["25F1", "25F2", "26S1", "26S2"];

export const employeeFormStatusData = [];

export const rewardCollectionData = [
  {
    id: 1,
    label: "Fall 1",
    status: true,
  },
  {
    id: 2,
    label: "Fall 2",
    status: false,
  },
  {
    id: 3,
    label: "Spring 1",
    status: false,
  },
  {
    id: 4,
    label: "Spring 2",
    status: false,
  },
  {
    id: 5,
    label: "December Bonus",
    status: false,
  },
  {
    id: 6,
    label: "OC Success Reward",
    status: false,
  },
];

export const rewarsNonEligibleEmployeeheaders = [
  "Employee ID",
  "Email",
  "First Name",
  "Last Name",
  "Total Points",
  "Selected Rewards",
  "Reward Amount ($)",
];

export const reportEventDetailsData = {
  "Event Name": "Convacation",
  "Event Location": "Sports Center",
  "Event Code": "2314",
  "Event Points": "Main Event (500 points)",
  "Event Date": "2026-01-31 | 10:00 AM",
  Term: "YYF1",
  "Hidden?": "NO",
  "Allow Early Check In?": "YES",
};

export const rewardEmployeeAttendance = [
  {
    employee_id: "EMP001",
    email: "john.doe@company.com",
    firstName: "John",
    lastName: "Doe",
    check_in_date_time: "2026-01-31 09:15 AM",
  },
  {
    employee_id: "EMP002",
    email: "jane.smith@company.com",
    firstName: "Jane",
    lastName: "Smith",
    check_in_date_time: "2026-01-31 09:18 AM",
  },
  {
    employee_id: "EMP003",
    email: "rahul.kumar@company.com",
    firstName: "Rahul",
    lastName: "Kumar",
    check_in_date_time: "2026-01-31 09:22 AM",
  },
  {
    employee_id: "EMP004",
    email: "anita.sharma@company.com",
    firstName: "Anita",
    lastName: "Sharma",
    check_in_date_time: "2026-01-31 09:30 AM",
  },
  {
    employee_id: "EMP005",
    email: "michael.brown@company.com",
    firstName: "Michael",
    lastName: "Brown",
    check_in_date_time: "2026-01-31 09:35 AM",
  },
];

export const SuccessRewardTableHeader = [
  "Employee ID",
  "VP Code",
  "First Name",
  "Last Name",
  "Fall 1 Points",
  "Fall 2 Points",
  "Spring 1 Points",
  "Spring 2 Points",
  "Selected Rewards",
  "Selected Term",
  "Award Amount ($)",
];

export const finalDrawingHeader = [
  "Employee ID",
  "Email",
  "First Name",
  "Last Name",
  "Fall 1 Points",
  "Fall 2 Points",
  "Spring 1 Points",
  "Spring 1 Points",
  "Entries",
];

export const employeeTypeStatus = [
  { id: "FT", displayName: "FT" },
  { id: "PT", displayName: "PT" },
];

export const employeeDepartmentData = [
  { id: "Physical Plant", displayName: "Physical Plant" },
  { id: "Social Science", displayName: "Social Science" },
  { id: "Testing Center", displayName: "Testing Center" },
  { id: "IT", displayName: "IT" },
];

export const employeeVPCodeData = [
  { id: "VP", displayName: "VP" },
  { id: "VPBA", displayName: "VPBA" },
  { id: "VPI", displayName: "VPI" },
  { id: "VPM", displayName: "VPM" },
];

export const rewardGiftCardData = [
  { id: "1", displayName: "Amazon" },
  { id: "2", displayName: "Academy" },
  { id: "3", displayName: "Apple Store" },
  { id: "4", displayName: "Best Buy" },
];

export const totalTermPontsTableHeader = [
  "Employee ID",
  "Email",
  "Last Name",
  "First Name",
  "Total Points",
];

export const completionStatisticsByTermHeader = [
  "Employee ID",
  "VP Code",
  "First Name",
  "Last Name",
  "Total Points",
  "DD",
  "TD",
];

export const pointsListedByVpHeader = [
  "Employee ID",
  "First Name",
  "Last Name",
  "Total Points",
];

export const eventAttandanceHeaders = [
  "Employee ID",
  "Email",
  "First Name",
  "Last Name",
  "Check In Date & Time",
];

export const individualPointSummaryXlHeader = [
  "Event",
  "Event Code",
  "Location",
  "Points",
  "Event Date",
];

export const employeeListHeaders = [
  "Employee ID",
  "Email",
  "First Name",
  "Last Name",
  "Status",
  "Department",
  "Web ID",
  "VP Code",
];

export const eventEmployee = [
  {
    id: 1,
    label: "Add Employee",
  },
  {
    id: 2,
    label: "Delete Employee",
  },
];

export const employeeMenu = [
  {
    id: 1,
    label: "Add Event",
  },
  {
    id: 2,
    label: "Delete Event",
  },
];
